import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { TranslateDirective, TranslatePipe } from "@ngx-translate/core";
import { NgTemplateOutlet, LowerCasePipe, DatePipe } from "@angular/common";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "rask-produktionsmal-plan-legend",
    templateUrl: "./produktionsmal-plan-legend.component.html",
    styleUrls: ["./produktionsmal-plan-legend.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateDirective,
        NgTemplateOutlet,
        NgbPopover,
        LowerCasePipe,
        DatePipe,
        TranslatePipe
    ]
})
export class ProduktionsmalPlanLegendComponent {

    @Input() produktionsomraden;
    @Input() produktionsmalPlan;
    @Input() detailMode = false;

    get produktionsomrade(): string {
        if (this.produktionsomraden &&
            this.produktionsmalPlan &&
            this.produktionsmalPlan.produktionsomradeId) {
            return this.produktionsomraden.filter(p => p.id ===
                this.produktionsmalPlan.produktionsomradeId)[0].namn;
        }

        return "";
    }
}
